<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<div class="shipment" *ngIf="shipment.shipment else spinner">
   <ng-container *ngFor="let item of components.shipmentComponents$ | async">
      <ng-container *ngComponentOutlet="item.component"></ng-container>
   </ng-container>
</div>
